/* sp-timeline.js — dikey zaman çizelgesi: nokta/çizgi hizalama (başlık bloğuna ortalanır) + kaydırma konumuna göre aktifleşme. Sabit metin yok. */
(function () {
  'use strict';
  class SpTimeline extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-sp-tl-item]'));
      if (!this.items.length) return;
      this.mode = this.dataset.activation || 'scroll';
      const at = parseFloat(this.dataset.activateAt);
      this.ratio = Math.min(0.9, Math.max(0.1, (isNaN(at) ? 50 : at) / 100));
      this.align();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { this.align(); this.update(); });
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.align());
        this.items.forEach((li) => { const h = li.querySelector('[data-sp-tl-head]'); if (h) this.ro.observe(h); });
      }
      if (this.mode !== 'scroll') { this.setActive(this.items.length - 1); return; }
      this.setActive(0);
      this.items.forEach((li, i) => {
        const t = li.querySelector('[data-sp-tl-text]');
        if (t) t.addEventListener('click', () => this.setActive(i));
      });
      /* Kaydırma konumu ne olursa olsun doğru durum: her kaydırma/boyut değişiminde yeniden hesapla.
         (IntersectionObserver tek başına yetmez: sayfa sonundan tepeye tek adımda dönülünce kesişim
         durumu "dışarıda"dan yine "dışarıda"ya geçtiği için geri çağrı tetiklenmez.) */
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.onScroll) { window.removeEventListener('scroll', this.onScroll); window.removeEventListener('resize', this.onScroll); }
      if (this.raf) cancelAnimationFrame(this.raf);
    }
    /* Öğe üst kenarı görünüm alanının %ratio çizgisinin üstündeyse aktif; birikimli (üsttekiler de aktif). */
    update() {
      const line = window.innerHeight * this.ratio;
      let last = 0;
      this.items.forEach((li, i) => { if (li.getBoundingClientRect().top <= line) last = i; });
      this.setActive(last);
    }
    setActive(k) {
      this.items.forEach((li, i) => {
        li.classList.toggle('is-active', i <= k);
        li.classList.toggle('is-open', i === k);
      });
    }
    /* Nokta: başlık bloğunun (etiket + başlık) dikey ortasına; çizgi: bir sonraki noktanın line-gap kadar üstüne uzar. */
    align() {
      const cs = getComputedStyle(this);
      const gap = parseFloat(cs.getPropertyValue('--sp-tl-items-gap')) || 0;
      const lineGap = parseFloat(cs.getPropertyValue('--sp-tl-line-gap')) || 0;
      const mts = this.items.map((li) => {
        const head = li.querySelector('[data-sp-tl-head]');
        const point = li.querySelector('[data-sp-tl-point]');
        if (!head || !point) return 0;
        const mt = Math.max(0, (head.offsetHeight - point.offsetHeight) / 2);
        point.style.marginTop = mt + 'px';
        return mt;
      });
      this.items.forEach((li, i) => {
        const line = li.querySelector('[data-sp-tl-line]');
        if (!line) return;
        line.style.marginBottom = i === this.items.length - 1 ? '' : (-(gap - lineGap + mts[i + 1])) + 'px';
      });
    }
  }
  if (!customElements.get('sp-timeline')) customElements.define('sp-timeline', SpTimeline);
})();
